import { Component, Input, inject, input, ChangeDetectionStrategy } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { OfferKind } from '@core/offers-types';

import { OfferStatusIndicatorComponent } from './../offer-status-indicator/offer-status-indicator.component';
@Component({
  selector: 'rt-offer-status',
  templateUrl: './offer-status.component.html',
  styleUrls: ['./offer-status.component.less'],
  host: {
    '[class.has-description]': 'description',
    '[class.status-title-visible]': 'showStatusTitle()',
    '[class.has-padding]': 'hasPadding()',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [OfferStatusIndicatorComponent],
})
export class OfferStatusComponent {
  private readonly i18n = inject(I18nService);

  public readonly showStatusTitle = input<boolean>(true);
  public readonly status = input<string>(undefined!);
  public readonly offerStatus = input<string>(undefined!);
  public readonly hasPadding = input<boolean>(false);
  @Input() public description: string;

  public get titleHTML(): string {
    const status = this.status();
    if (this.offerStatus() === status) {
      return this.i18n.translate(`app.offers.human_statuses.${status}`);
    } else {
      let inactiveStatus = '';
      switch (status) {
        case 'archived':
          inactiveStatus = 'archive';
          break;

        case 'closed':
          inactiveStatus = 'close';
          break;

        case 'published':
          inactiveStatus = 'publish';
          break;

        default:
          inactiveStatus = status;
          break;
      }

      return this.i18n.translate(`app.offers.human_statuses.do.${inactiveStatus}`);
    }
  }

  public offerKind: typeof OfferKind = OfferKind;
}
